import React, { useEffect, useState } from "react";
import Common_Back_Header from "../../../../common/common_components/common_back_header/Common_Back_Header";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Order_details_table from "../order_details/order_details_table/Order_details_table";
import Order_Status_Stepper from "../order_details/order_status_stepper/Order_Status_Stepper";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "../order_details/payment_summary/Payment_Summary";
import Light_Black_Btn from "../../../../common/common_btn/light_black_btn/Light_Black_Btn";
import './Cancelled_Order_Details.css'
import { useDispatch, useSelector } from "react-redux";
import { getCanceledOrder } from "../../../../../features/order/orderSlice";
import { useParams } from "react-router-dom";
import Order_Cancel_Details_Table from "../order_details/order_cancel_details_table/Order_Cancel_Details_Table";
import { decodeId } from "../../../../../utils/common";

function Cancelled_Order_Details() {
  const [showStepper, setShowStepper] = useState(false);

  const orderStatusClickFunc = () => {
    setShowStepper(true);
  };

  const { id } = useParams();

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getCanceledOrder(decodeId(id)));
    if (res.meta?.requestStatus === "fulfilled") {
      // setShowCancelBtn(true);
    } else if (res.meta?.requestStatus === "rejected") {
      // setShowCancelBtn(false);
    }
  }, [dispatch]);

  const data = {
    total_mrp: order?.total_mrp,
    total_tax: order?.total_tax,
    total_cess: order?.cess_tax,
    no_of_item: order?.quantity,
    total_selling_price: order?.total_selling_price,
    total_selling_price_gst: order?.total_selling_price_gst,
    total_mrp_gst: order?.total_mrp_gst,
    total_coupon_discount: order?.total_coupon_discount,
    total_offer_discount: order?.total_offer_discount,
    grand_total: order?.total_amount,
    total_delivery_charges: order?.delivery_charges,
    platform_fee: order?.platform_fee,
    payment_method: order?.Payment_Method?.name,
    total_savings: order?.total_mrp - order?.total_selling_price
  };

  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header backNavigation="/profile" />

          {/* <div className="reorder_btn">
            <Light_Black_Btn btnText={"Reorder"} />
          </div> */}

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
                headingText={`Order ID #${order?.Product_Order?.invoice_no}`}
                subText="Cancelled"
                date={order?.Product_Order?.createdAt}
              />
              <Order_Cancel_Details_Table product={order || {}} />
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder User={order?.Product_Order?.User} Address={order?.Product_Order?.User_Address} id={decodeId(id)} />

              <Payment_Summary isCheckoutPage data={data} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Cancelled_Order_Details;
